import { makeObservable, observable } from "mobx";
import { TYPES } from "react-sdk/activities/ActivitiesConverter";
import Minigames from "./Minigames";
import Chapters from "../Chapters";
import Chapter from "../Chapter";

class Minigame {
  /** @type {DataLine} */
  line;

  /** @type {Array<Minigame>} */
  children = null

  /**
   * Score compris entre 0 et 1. La valeur n'est pas utilisé si ce Minigame est en fait un groupement de minigames (c'est à dire s'il a des enfants)
   */
  score = 0;

  /**
   * Multiplicateur de score pour obtenir le nombre d'étoiles
   */
  scoreFactor = 1;

  /**
   * Nombre d'étoiles gagnées (calculé lors du setScore)
   */
  stars = 0


  constructor(dataLine) {
    this.line = dataLine;
    let value = this.line.getEvaluated("scoreFactor");
    if (value != null)
      this.scoreFactor = value

    makeObservable(this, {
      score : observable,
      stars : observable
     })
  }
  /**
   * Sauvegarde le score actuel
   * @param {number} score (ratio entre 0 et 1)
   */
  setScore(score) {
    this.score = score;
    this.stars = Math.round(score * this.scoreFactor);
  }

  /**
   * Renvoie le score du minigame :
   * - si c'est un MG avec des enfants, alors on renvoie la moyenne des scores des enfants
   * - sinon on renvoie le score (précédement indiqué via setScore)
   * @returns
   */
  getScore() {
    if (this.isContainer())
      return this.children.reduce((total, mg) => total + mg.getScore(), 0) / this.children.length
    else
      return this.score
  }

  /**
   * Calcule les étoiles en se basant sur les scores des enfants, s'il y en a, ou sur le dernier score donné (via setScore)
   */
  getStars() {
    if (this.isContainer())
      return this.children.reduce((total, mg) => total + mg.getStars(), 0)
    else
      return this.stars
  }

  isContainer() {
    return (this.children && this.children.length > 0);
  }

  findCurrentMinigameIndex(current) {
    if(!this.isContainer) return null

    return this.children.findIndex(child => child === current);

  }

  get id() {
    return this.line.id
  }
  get description() {
    return this.line.getEvaluated("description")
  }
  get name() {
    return this.line.get("name")
  }
  get type() {
    return this.line.get("type")
  }
  get ref() {
    return this.line.get("ref")
  }
  get icon() {
    return this.line.get("icon")
  }
  get chapterRef() {
    return this.line.get("chapterRef")
  }

  /**
   * @returns {Chapter}
   */
  get chapter() {
    let ref = this.chapterRef
    if (ref)
      return Chapters.get(ref)
    else
      return null
  }

  get elementRef() {
    let ref = this.ref

    console.log(ref)

    if (!ref) return null;

    if (this.type === TYPES.QCM)
      return Minigames.qcms.get(ref);
    if (this.type === TYPES.QRL)
      return Minigames.qrls.get(ref);
    else if (this.type === TYPES.DRAGDROP)
      return Minigames.dragdrops.get(ref);
    else if (this.type === TYPES.REORDONNER)
      return Minigames.reordonners.get(ref);
    else if (this.type === TYPES.SWIPE)
      return Minigames.swipes.get(ref);
    else
      return null;
  }

  reset() {
    let elRef = this.elementRef
    if (elRef) {
      this.score = 0
      elRef.reset()
    }
  }

  stateToJson() {
    let ref = this.elementRef;
    if (ref) {
      return {
        score : this.score,
        stars : this.stars,
        state : ref.getState()
      }
    }
  }

  stateFromJson(state) {
    let ref = this.elementRef;
    if (ref) {
      this.score = state.score
      this.stars = state.stars
      ref.setState(state.state)
    }
  }

}

export default Minigame;
